import { Skeleton, Stack } from "@mui/material";
import * as React from "react";
export const CardsLoader = (props) => {
  return (
    <Stack
      sx={{
        flexDirection: "row",
        rowGap: "24px",
        columnGap: "38px",
        mb: "24px",
      }}
    >
      {Array.from({ length: 4 }).map((_, index) => (
        <Skeleton variant="rounded" width="25%" height={88} key={index} />
      ))}
    </Stack>
  );
};
